import React, { useState, useEffect } from "react";
import hero from "./Hero.module.css";
// import { fetchBlog } from '../../Api/fetchApi';

import { IoMdArrowUp } from "react-icons/io";
import { Link } from "react-router";
// import { fetchData } from '../../Api/PostManApi';
import {
  fetchAllPosts,
  getAllTechTv,
  imageUrl,
  convertToDate,
  getFirstNWords,
} from "../../Api/PostManApi";

const Hero = () => {
  const scrollToTop = () => {
    document.getElementById("homepage").scrollIntoView({ behavior: "smooth" });
  };

  const [hotPost, setHotPost] = useState("");
  const [latest, setLatest] = useState([]);
  const [posts, setPosts] = useState([]);
  const [editorPick, setEditorPick] = useState("");
  const [techTv, setTechTv] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const [postResponse, tvResponse] = await Promise.all([
          fetchAllPosts(),
          getAllTechTv(),
        ]);
        console.log("Fetched posts:", postResponse);

        const postsArray = Array.isArray(postResponse)
          ? postResponse
          : postResponse.data && Array.isArray(postResponse.data.posts)
          ? postResponse.data.posts
          : [];

        if (postsArray.length > 0) {
          setHotPost(postsArray[0]);
          setLatest(postsArray.slice(1, 3));
          setPosts(postsArray.slice(3, 10));
          setTechTv(tvResponse);

          // Find editor's pick - with fallback
          const editorPickPost =
            postsArray.find((post) => post.editorPick === true) ||
            postsArray[0]; // fallback to first post if none marked as editor's pick
          setEditorPick(editorPickPost);

          console.log("Editor's pick:", editorPickPost);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPosts();
  }, []);
  return (
    <div className={hero.hero} id="homepage">
      <div className={hero.container}>
        <div className={hero.content}>
          <div className={hero.flex}>
            <div className={hero.flexI}>
              <div className={hero.secI}>
                <Link to={`/${latest[0]?.slug}`}>
                  <p>Latest news</p>
                  <h4>
                    {latest[0]?.title}
                    {/* From nairaland to AI: Unilag student azeez merged technology
                    with culture */}
                  </h4>
                  <img
                    src={`${imageUrl}/post_images/${latest[0]?.images}`}
                    alt=""
                  />
                </Link>
              </div>
              <div className={hero.secII}>
                <Link to={`/${latest[1]?.slug}`}>
                  <h4>{latest[1]?.title}</h4>
                  <img
                    src={`${imageUrl}/post_images/${latest[1]?.images}`}
                    alt=""
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className={hero.flexII}>
            <Link to={`/${hotPost?.slug}`} state={{ source: "A" }}>
              <p>Hot News</p>
              <h3>{hotPost?.title}</h3>
              <img src={`${imageUrl}/post_images/${hotPost?.images}`} alt="" />

              <p>
                {getFirstNWords(hotPost?.description)}{" "}
                {/* {post.description.split(/\s+/).length > 150} */}
                <span>More</span>
                {/* {hotPost?.description} */}
                {/* Kenyan citizen Dennis Gathara prevailed in his case before the
                against GoodTimes Africa for sending him unsolicited marketing
                texts without an opt-out button. The ODPC ordered the company to
                pay KES 700,000 in compensation and delete the complainant’s
                personal data within 14 days. This is one of many sanctions
                against organisations that breach Kenya’s Data Protection Act.
                Last week, ODPC ordered Bolt to pay KES 500,000 in compensation
                to its driver for violating data protection rights. */}
              </p>
            </Link>
          </div>
        </div>
        <div className={hero.topI}>
          <div className={hero.top} onClick={scrollToTop}>
            <IoMdArrowUp className={hero.icons} />
          </div>
        </div>
        <div className={hero.her}>
          <button>Trending News</button>
          <div className={hero.contentII}>
            {posts.slice(0, 4).map((post) => (
              <div className={hero.cardI} key={post.slug}>
                <Link to={`/${post?.slug}`}>
                  <img src={`${imageUrl}/post_images/${post?.images}`} alt="" />
                  <p>{post?.title}</p>
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className={hero.contentIII}>
          <div className={hero.flexIII}>
            <h5>Editor’s Picks</h5>

            <div className={hero.secIV}>
              <img
                src={`${imageUrl}/post_images/${editorPick?.images}`}
                alt=""
              />
              <Link to={`/${editorPick?.slug}`}>
                <p>{editorPick?.title}</p>
              </Link>
            </div>
            <div className={hero.blockI}>
              <div className={hero.blogII}>
                <div className={hero.blog1}>
                  <button>Exclusive News</button>
                  <Link to={`/${posts[4]?.slug}`}>
                    <p>{posts[4]?.title}</p>
                  </Link>
                  <h6>{convertToDate(posts[4])}</h6>
                </div>
                <img
                  src={`${imageUrl}/post_images/${posts[4]?.images}`}
                  alt=""
                />
              </div>
              <div className={hero.blogIII}>
                <div className={hero.blogIV}>
                  <button>Techpression TV</button>
                  <p>{techTv[0]?.title}</p>
                  <h6>
                    {techTv?.createdAt
                      ? `${Math.floor(
                          Math.abs(new Date() - new Date(techTv?.createdAt)) /
                            (1000 * 60 * 60)
                        )} hrs ago`
                      : ""}
                  </h6>
                </div>
                <div className={hero.vid}>
                  <iframe
                    width="340"
                    height="200"
                    src={techTv[0]?.url}
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; 
                       gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
          <div className={hero.flexIV}>
            <div className={hero.post}>
              <h2>ADS POST</h2>
            </div>
            {posts.slice(3, 8).map((post) => (
              <div className={hero.tiktoc}>
                <h6>{convertToDate(post)}</h6>
                <Link to={`/${post?.slug}`}>
                  <p>{post?.title} </p>
                </Link>
              </div>
            ))}
            {/* <div className={hero.tiktoc}>
              <h6>2hr ago</h6>
              <p>
                TikTok Deletes over 20 million <br />
                videos across africa, enforcing{" "}
              </p>
            </div>
            <div className={hero.tiktoc}>
              <h6>2hr ago</h6>
              <p>
                TikTok Deletes over 20 million <br />
                videos across africa, enforcing{" "}
              </p>
            </div>
            <div className={hero.tiktoc}>
              <h6>2hr ago</h6>
              <p>
                TikTok Deletes over 20 million <br />
                videos across africa, enforcing{" "}
              </p>
            </div>
            <div className={hero.tiktoc}>
              <h6>2hr ago</h6>
              <p>
                TikTok Deletes over 20 million <br />
                videos across africa, enforcing{" "}
              </p>
            </div> */}
          </div>
        </div>
        <div className={hero.contentIV}>
          <h2>ADS POST</h2>
        </div>
      </div>
    </div>
  );
};

export default Hero;
